// extracted by mini-css-extract-plugin
export default {"recent-transactions":"style_recent-transactions__FxgOU","feed":"style_feed__fbuif","transaction":"style_transaction__IEkvm","avatar":"style_avatar__xNez+"};